
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: "search-score",
components: {
XHeader,Selector,XTextarea,Group
},
mounted(){
var _this = this;
_this.currentterm = _this.termlist[0].key;
_this.$http.post('/searchapi/wechat/student/querySemester',{q:_this.$store.state.stu_num})
.then(function (response) {
var data = response.data;
if (data.code == "0"){
_this.currentterm = data.results.currentSem;
_this.semesters = data.results.semesters;
var tmpList = [];
for (var i = 0;i < _this.semesters.length; i++){
var tmpObj = _this.resetSem(_this.semesters[i]);
tmpList.push(tmpObj)
}
_this.termlist = tmpList;
_this.getScore(_this.currentterm);
}else {
_this.$msgbox('温馨提示',"当前没有可查询的学期");
}
})
.catch(function (error) {
that.$msgbox('温馨提示','系统内部异常，请联系管理员！');
})
},
data() {
return {
advice:''
}
}
}



// WEBPACK FOOTER //
// ./src/components/Advice.vue